export default "__VITE_ASSET__B7ZNd0Aw__"